import React from "react";
import { X } from "lucide-react";

const statusLabels = {
  NOT_STARTED: "Non commence",
  IN_PROGRESS: "En cours",
  COMPLETED: "Termine",
  FAILED: "Echoue",
  LOCKED: "Verrouille",
};

const formatDate = (value) =>
  value ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value)) : "-";

const contentMeta = (content) => {
  if (content.scorm) {
    return `Score ${content.scorm.scoreScaled != null ? Math.round(content.scorm.scoreScaled * 1000) / 10 : content.scorm.scoreRaw ?? "-"} - ${content.scorm.interactionsCount || 0} interactions`;
  }
  if (content.quiz) {
    return `Score ${content.quiz.score ?? "-"} - ${content.quiz.attemptsCount || 0} tentative(s)`;
  }
  if (content.evaluation) {
    return content.evaluation.submitted ? `Soumis le ${formatDate(content.evaluation.submittedAt)}` : "Non soumis";
  }
  if (content.certificate) {
    return content.certificate.generated ? `Généré le ${formatDate(content.certificate.generatedAt)}` : "Non généré";
  }
  return `${content.progressPercent || 0}%`;
};

export default function LmsLearnerDetailModal({ detail, loading, onClose }) {
  if (!detail && !loading) return null;

  return (
    <div className="lms-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="lms-modal" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <div className="lms-modal-header">
          <div>
            <h2>{loading ? "Chargement..." : detail.fullName}</h2>
            <p>{detail?.email}</p>
          </div>
          <button className="lms-icon-button" type="button" onClick={onClose} title="Fermer">
            <X size={18} />
          </button>
        </div>

        {loading ? (
          <div className="lms-report-empty">Chargement du detail LMS...</div>
        ) : (
          <>
            <section className="lms-detail-kpis">
              <div>
                <span>Progression</span>
                <strong>{detail.progressPercent || 0}%</strong>
              </div>
              <div>
                <span>Score</span>
                <strong>{detail.score == null ? "-" : Math.round(detail.score * 10) / 10}</strong>
              </div>
              <div>
                <span>Contenus</span>
                <strong>{detail.completedContentsCount || 0} / {detail.totalContentsCount || 0}</strong>
              </div>
              <div>
                <span>Bloquants</span>
                <strong>{detail.blockingContentsCount || 0}</strong>
              </div>
            </section>

            <h3>Details par contenu</h3>
            <div className="lms-detail-list">
              {(detail.contents || []).map((content) => (
                <article className="lms-detail-card" key={content.contentId}>
                  <div>
                    <strong>{content.title}</strong>
                    <span>{content.sectionTitle || "Sans section"} - {content.type}</span>
                  </div>
                  <div>
                    <span className={`lms-status lms-status-${String(content.status || "").toLowerCase()}`}>
                      {statusLabels[content.status] || content.status}
                    </span>
                    <em>{contentMeta(content)}</em>
                  </div>
                  {content.blocking && <p>{content.blockingReason}</p>}
                </article>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
